export enum ServerDataBackupDialogMessagesEnum {
    OverrideServerDataTitle = 'The restore process will completely override the current date in the system.',

    OnBrowserTabClosedWhileDownloading = 'Backup file downloading is in progress. Are you sure you want to reload the page?',
    OnAdminTabChangedWhileDownloading = 'Backup file downloading is in progress. Are you sure you want to go to the another page?',
    OnAdminTabChangedWhileUnpacking = 'Backup file unpacking is in progress. Are you sure you want to go to the another page?',

    WrongFileTypeUploadingTitle = 'Wrong file type',
    WrongFileTypeUploadingDescription = 'You can upload only \'zip\' files'
}
